import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { PaymentDiscount } from 'src/app/entities/payment-discount';
import { PaymentDiscountService } from 'src/app/services/payment-discount.service';
import { BaseAddComponent } from '../base-add/base-add.component';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-payment-discount-add',
  templateUrl: './payment-discount-add.component.html',
  styleUrls: ['./payment-discount-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class PaymentDiscountAddComponent extends BaseAddComponent<PaymentDiscount> implements OnInit {

  pathUrlList = 'payment-discount';
  categoriesParents = new Array<PaymentDiscount>();

  constructor(
    protected discountService: PaymentDiscountService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = discountService;
    this.item = new PaymentDiscount();
    this.initFields();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'title',
        title: 'Titulo',
        caption: ''
      },
      {
        type: 'select',
        key: 'type_id',
        title: 'Tipo',
        caption: '',
        options: [
          {
            title: 'MutualCard',
            value: 1
          },
          {
            title: 'Efectivo',
            value: 2
          }
        ]
      },
      {
        type: 'string',
        key: 'percent',
        title: 'Porciento',
        caption: ''
      },
      {
        type: 'string',
        key: 'from',
        title: 'Desde (YYYY-MM-DD)',
        caption: '',
        placeholder: 'YYYY-MM-DD'
      },
      {
        type: 'string',
        key: 'to',
        title: 'Hasta (YYYY-MM-DD)',
        caption: '',
        placeholder: 'YYYY-MM-DD'
      },
      {
        type: 'select',
        key: 'status',
        title: 'Activo',
        caption: '',
        options: [
          {
            title: 'SI',
            value: 1
          },
          {
            title: 'NO',
            value: 0
          }
        ]
      }
    ];
  }

}